import { FleetVehicle } from '../../types';

import './index.css';

export const TableViewerComponent = ({
  data = [],
  columns = [],
  extraColumn = [],
}: any) => {
  return (
    <div className='tv-table-container'>
      <table>
        <thead className='tv-table-head'>
          <tr className={`tv-table-head-tr tv-grid-columns-${columns.length}`}>
            {columns?.map((column: any, thIndex: number) => (
              <th
                className={`tv-table-head-th tv-th-align-${column.align}`}
                key={thIndex}
              >
                <div className={`tv-th`}>
                  {column.icon && (
                    <img
                      src={column.icon}
                      alt={column.label}
                      className='tv-table-icon'
                    />
                  )}
                  {column.label && <span>{column.label}</span>}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='tv-table-body'>
          {!data.length && <div className='tv-table-no-data'>Sem dados.</div>}
          {data?.map((fv: FleetVehicle, trIndex: number) => {
            const hasExtraConfigColumn = extraColumn.length > 0;
            return (
              <>
                <tr
                  key={trIndex}
                  className={`${
                    !hasExtraConfigColumn ? 'tv-charger-info-tr' : ''
                  } tv-grid-columns-${columns.length}`}
                >
                  {columns?.map((column: any, tdIndex: number) => (
                    <td className={`tv-th-align-${column.align}`} key={tdIndex}>
                      {column?.render && column?.render(fv)}
                    </td>
                  ))}
                </tr>
                {hasExtraConfigColumn && (
                  <tr
                    key={trIndex + 'a'}
                    className={`tv-charger-info-tr tv-grid-columns-colspan-${columns.length}`}
                  >
                    {extraColumn?.map((column: any, tdIndex: number) => (
                      <td
                        className={`tv-th-align-${column.align} no-padding`}
                        key={tdIndex}
                        colSpan={column.colspan as number}
                      >
                        {column?.render && column?.render(fv)}
                      </td>
                    ))}
                  </tr>
                )}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
